import { useEffect } from "react";
import { Form, Input, Space } from "antd";
import { LockOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";

import { REDUX as REDUX_UTIL } from "../../../../../services/util";

const { reduxStoreWrapper } = REDUX_UTIL;

const MyProfile = (props) => {
  const { form, isEditing } = props;

  const user = useSelector(reduxStoreWrapper("user"));

  useEffect(() => {
    if (user) {
      const contactCode = user.contact ? user.contact.slice(0, 3) : "";
      const contactNumber = user.contact ? user.contact.slice(3) : "";

      form.setFieldsValue({
        name: user.name,
        position: user.position,
        email: user.email,
        contactCode: contactCode,
        contactNumber: contactNumber,
      });
    }

  }, [user]);

  return (
    <div>
      <Form form={form} name="profileForm" layout="vertical">
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Please input your name!" }]}
        >
          <Input
            style={{ width: "20rem" }}
            placeholder="Enter your name"
            disabled={!isEditing}
          />
        </Form.Item>

        <Form.Item
          label="Job Position"
          name="position"
          rules={[
            { required: true, message: "Please input your job position!" },
          ]}
        >
          <Input
            style={{ width: "20rem" }}
            placeholder="Enter your job position"
            disabled={!isEditing}
          />
        </Form.Item>

        <Form.Item
          label="Email"
          name="email"
          rules={[
            { required: true, message: "Please input your email!" },
            { type: "email", message: "Please enter a valid email!" },
          ]}
          hasFeedback
          validateStatus={form.getFieldValue("email") ? "success" : "error"}
        >
          <Input
            suffix={isEditing ? <LockOutlined /> : null}
            style={{ width: "20rem" }}
            placeholder="Enter your email"
            // disabled={!isEditing || user?.uroleid === "A"}
            disabled
          />
        </Form.Item>
        
        {user?.uroleid === "A" ? (
          <></>
        ) : (
          <Form.Item
            label="Contact"
            rules={[
              { required: true, message: "Please input your contact number!" },
            ]}
            style={{ width: "20rem" }}
          >
            <Space.Compact>
              <Form.Item
                name="contactCode"
                noStyle
                rules={[
                  { required: true, message: "Please input your contact code!" },
                ]}
              >
                <Input
                  style={{ width: "20%" }}
                  placeholder="Code"
                  disabled={!isEditing}
                />
              </Form.Item>
              <Form.Item
                name="contactNumber"
                noStyle
                rules={[
                  {
                    required: true,
                    message: "Please input your contact number!",
                  },
                ]}
              >
                <Input
                  suffix={isEditing ? <LockOutlined /> : null}
                  style={{ width: "80%" }}
                  placeholder="Number"
                  disabled={!isEditing}
                />
              </Form.Item>
            </Space.Compact>
          </Form.Item>
        )}
      </Form>
    </div>
  );
}

export default MyProfile;
